import isEmpty from 'lodash/isEmpty';
import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { AbacusIcon } from '../../../../atoms/material-icons';
import { fetchStockId } from '../../utils/marketsUtils';
import EmptyState from '../empty-state';
import './stock-fundamentals.m.css';

const StockFundamentals = () => {
  const [fundamentalsData, setFundamentalsData] = useState({});
  const [requiredGraphData, setRequiredGraphData] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [toggle, setToggle] = useState(-1);
  const graphDataArray = [];
  const labelsArray = [];
  const [initialLoading, setInitialLoading] = useState(true);

  const displayValueMapping = {
    priceToAdjBook: 'Price to Adj Book Value',
    marketCap: 'Market Cap',
    dividendYield: 'Dividend Yield (%)',
    returnOnAssets: 'Return on Assets (ROA)',
    netNPA: 'Net NPA (%)',
    grossNPA: 'Gross NPA (%)',
    capitalAdequacy: 'Capital Adequacy Ratio',
    priceToEquity: 'PE (TTM)',
    returnOnEquity: 'Return on Equity (ROE)',
    debtToEquityRatio: 'Debt to Equity Ratio',
    priceToBook: 'Price to Book (P/BV)',
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const getFundamentalsData = async () => {
      const urlStockId = fetchStockId();
      const response = await fetch(`/next/feapi/stock/fundamentals/${urlStockId}`);
      const data = await response.json();
      const overallData = data?.data;
      setFundamentalsData(overallData);
      const filteredItemsFromOriginalData = Object.keys(overallData).filter(
        (valuePoint) => overallData[valuePoint][0]?.value,
      );
      setFilteredItems(filteredItemsFromOriginalData);
      setRequiredGraphData(overallData[filteredItemsFromOriginalData[0]]);
      setToggle(0);
    };
    getFundamentalsData();
  }, []);

  requiredGraphData?.map((dataPoint) => {
    graphDataArray.push(dataPoint.value);
  });

  requiredGraphData?.map((dataPoint) => {
    labelsArray.push(dataPoint.name);
  });

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      x: {
        ticks: {
          display: false,
        },
        grid: {
          drawBorder: true,
          display: true,
        },
      },
      y: {
        ticks: {
          display: true,
        },
        grid: {
          drawBorder: true,
          display: true,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
        position: 'top',
      },
      title: {
        display: false,
        text: '',
      },
    },
  };

  const labels = labelsArray;

  const data = {
    labels,
    datasets: [
      {
        label: 'Fundamentals',
        data: graphDataArray,
        backgroundColor: '#14c588',
      },
    ],
  };

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  return (
    <div styleName="stock-fundamentals-container">
      <div styleName="header-title-container">
        <AbacusIcon size={'26px'} color={'#d01e51'} />
        <h2 styleName="list-header-title">FUNDAMENTALS</h2>
      </div>
      {!fundamentalsData || isEmpty(fundamentalsData) || filteredItems?.length === 0 ? (
        <div styleName="no-data-container-ext">
          <div styleName="no-data-container-int">
            <EmptyState subTextMessage={'for this stock at the moment'} />
          </div>
        </div>
      ) : (
        <>
          <div styleName="graph-container">
            <Bar options={options} data={data} />
          </div>
          <div styleName="fundamentals-body">
            <table>
              {Object.keys(fundamentalsData)
                .filter((valuePoint) => fundamentalsData[valuePoint][0]?.value)
                .map((value, index) => (
                  <tr
                    styleName={index === toggle && 'selected'}
                    key={value}
                    onClick={() => {
                      setRequiredGraphData(fundamentalsData?.[value]);
                      setToggle(index);
                    }}
                  >
                    <td>{displayValueMapping[value]}</td>
                    <td>
                      {fundamentalsData?.[value] && fundamentalsData?.[value][0]?.value
                        ? fundamentalsData?.[value][0].value
                        : 0}
                    </td>
                  </tr>
                ))}
            </table>
          </div>
          <div styleName="discliamer-container">
            <span styleName="disclaimer">*Closest peers by market cap</span>
          </div>
        </>
      )}
    </div>
  );
};

export default StockFundamentals;
